var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "application-page jobs" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("Navigation", {
                    attrs: {
                      page: "jobs",
                      only:
                        _vm.loading || _vm.jobForOnboarding
                          ? ["logout"]
                          : undefined
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "7" } },
                [
                  _vm.loading
                    ? _c("Loading")
                    : [
                        _c("h1", [
                          _vm._v(
                            _vm._s(
                              _vm.jobForOnboarding
                                ? "Hallo " + _vm.application.firstName + "!"
                                : "Matches"
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _vm.jobForOnboarding
                          ? _c("Onboarding", {
                              attrs: {
                                job: _vm.jobForOnboarding,
                                "application-data": _vm.applicationData
                              },
                              on: {
                                continueLater: _vm.onContinueLater,
                                close: _vm.onClose
                              }
                            })
                          : !_vm.loadingJobs || _vm.initiallyLoadedJobs
                          ? _c("Listing", {
                              class: { "loading-blockaed": _vm.loadingJobs },
                              attrs: {
                                jobs: _vm.jobs,
                                "loading-jobs": _vm.loadingJobs,
                                "jobs-to-show-results-for":
                                  _vm.jobsToShowResultsFor
                              },
                              on: {
                                publish: _vm.loadJobs,
                                unpublish: _vm.loadJobs,
                                save: _vm.loadJobs,
                                jobChanged: _vm.loadJobs,
                                messagesClosed: _vm.loadJobs
                              }
                            })
                          : _vm._e()
                      ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }